<template>
  <div class="ContentBox">
    <div class="commonBox TopsBlack"><Tops :ishome="false" /></div>
    <el-carousel class="bannerBox" trigger="click" indicator-position="outside">
      <el-carousel-item v-for="item in 1" :key="item">
        <img src="@/assets/banner-2.png" />
      </el-carousel-item>
    </el-carousel>
    <!--  -->
    <PathBox />
    <!--  -->
    <div class="CentBox">
      <div style="height:50px"></div>
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="联系人">
          <el-input v-model="form.UserName"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="form.other"></el-input>
        </el-form-item>
         <!-- <el-form-item label="联系地址">
          <el-input v-model="form.Address"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="反馈类型">
          <el-checkbox-group v-model="form.TargetType">
            <el-checkbox label="优化建议" name="type" value="0"></el-checkbox>
            <el-checkbox label="内容错误" name="type" value="1"></el-checkbox>
            <el-checkbox label="功能错误" name="type" value="2"></el-checkbox>
          </el-checkbox-group>
        </el-form-item> -->
        <el-form-item label="反馈内容">
          <el-input type="textarea" v-model="form.Info" resize='none'></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" style="background:rgba(65, 96, 206, 0.9);color:#fff">立即反馈</el-button>
          <!-- <el-button>取消</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <Footer />
  </div>
</template>
<script>
import Tops from "@/components/PubBox/hearTop.vue";
import Footer from "@/components/PubBox/footer.vue";
import PathBox from "@/components/PubBox/PathBox.vue";
import {addMsg} from '@/requestPub/api';
export default {
  components: {
    Tops,
    Footer,
    PathBox
  },
  data() {
    return {
      form: {
        UserName: "",
        other:'',
        Info: "",
      },
    };
  },
  methods: {
    onSubmit() {
      var parames = this.form;
      if(!parames['UserName'] || !parames['other'] || !parames['Info']){
          return this.$message({message:'请先完善信息',type:'warning'});
      }
      parames['ColumnID'] = 14;
      addMsg(parames).then((e)=>{
          this.$message({message:'提交成功',type:'success'});
          this.form={
            UserName: "",
            other:'',
            Info: "",
          }
      })
    },
  },
};
</script>
<style lang="scss">
.el-timeline {
  padding: 0;
}
.el-textarea__inner{
    min-height: 200px!important;
}
.bannerBox {
  height: 400px;
  .el-carousel__container {
    height: 100%;
  }
  .el-carousel__indicators--outside {
    position: absolute;
    bottom: 100px;
  }
  .el-carousel__item {
    img,
    .el-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
// ConetBox
.CentBox {
    width: 60%;
    margin: 0 auto;
    text-align: left;
}
</style>